import { useEffect, useState } from "react";
import { H5, Image, LI } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import UserProfileIcons from "./UserProfileIcons";
import { formatPhoneNumber } from "../../../../utils/helper/helpers";

const UserProfile = () => {
  const [show, setShow] = useState(false);
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const updateUserFromLocalStorage = () => {
    const updatedUser = localStorage.getItem("user");
    setUser(updatedUser ? JSON.parse(updatedUser) : null);
  };

  useEffect(() => {
    // Écouter les changements dans le localStorage
    window.addEventListener("storage", updateUserFromLocalStorage);

    // Écouter l'événement personnalisé
    document.addEventListener("userUpdated", updateUserFromLocalStorage);

    return () => {
      window.removeEventListener("storage", updateUserFromLocalStorage);
      document.removeEventListener("userUpdated", updateUserFromLocalStorage);
    };
  }, []);

  if (!user) {
    return null; // Afficher un état vide ou un message par défaut
  }

  return (
    <LI className="profile-dropdown custom-dropdown">
      <div className="d-flex align-items-center" onClick={() => setShow(!show)}>
        <Image src={dynamicImage("profile.png")} alt="avatar" />
        <div className="flex-grow-1">
          <H5>{user.name + " " + user.firstname}</H5>
          <span>{formatPhoneNumber(user.phone)}</span>
        </div>
      </div>
      <div className={`custom-menu overflow-hidden ${show ? "show" : ""}`}>
        <UserProfileIcons />
      </div>
    </LI>
  );
};

export default UserProfile;
